import TailorState from '../interfaces/state';

const tailorInitialState: TailorState = {
  tailors: [],
  tailorPlaceDetails: null,
};

export default tailorInitialState;
